import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";
import noop from "lodash/noop";

import { ReplayAnimationDecorator } from "@/__stories__/ReplayAnimationDecorator";
import { OnboardingSplashScreen } from "@/ui/components/onboarding/v2/OnboardingSplashScreen";
import { Box } from "@/ui/layout";
import RadialGradientBackground from "@/ui/layout/RadialGradientBackground";

const StoryMeta: Meta = {
  title: "Components/Onboarding/Splash Screen",
};

type Story = StoryObj;

enum SplashPreview {
  Height = 844,
  MaxWidth = 390,
}

const appUser = faker.person.firstName();
const patientName = faker.person.firstName();

const Patient: Story = {
  render: () => (
    <ReplayAnimationDecorator>
      <Box height={SplashPreview.Height} maxWidth={SplashPreview.MaxWidth}>
        <RadialGradientBackground testID="story">
          <OnboardingSplashScreen appUser={appUser} onContinuePress={noop} />
        </RadialGradientBackground>
      </Box>
    </ReplayAnimationDecorator>
  ),
};

const ProxySupport: Story = {
  render: () => (
    <ReplayAnimationDecorator>
      <Box height={SplashPreview.Height} maxWidth={SplashPreview.MaxWidth}>
        <RadialGradientBackground testID="story">
          <OnboardingSplashScreen
            appUser={appUser}
            onContinuePress={noop}
            patientName={patientName}
          />
        </RadialGradientBackground>
      </Box>
    </ReplayAnimationDecorator>
  ),
};

export { Patient, ProxySupport };
export default StoryMeta;
